export default __webpack_public_path__ + "static/stative-compound-transitive-cb64f77ce16d2d0d244603ecad387a29.svg";